import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title"
}

import { isExpand } from "@/views/Home/useData/useHomePage";
import publicStore from "@/store/publicStore";
import { storeToRefs } from "pinia";
import { openLoginDialog } from "@/components/Dialogues/useData/login";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatListEmpty',
  setup(__props) {

const { isLogin } = storeToRefs(publicStore());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(isExpand) && !_unref(isLogin))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createTextVNode(" 请 ")),
          _createElementVNode("div", {
            class: "login",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(openLoginDialog) && _unref(openLoginDialog)(...args)))
          }, "登录"),
          _cache[2] || (_cache[2] = _createTextVNode(" 获取会话 "))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})